import {Injectable} from '@angular/core';
import {ColumnConfig} from '@bmc-ux/adapt-table';
import {COLUMN_HEADER} from '../models/table';

type Primitive = boolean | number | string | null;

@Injectable({
  providedIn: 'root'
})
export class GlobalTableFilterService {
  private static readonly SPLIT_KEY = ' ';

  public filterTableRows<T>(rowsData: T[], inputValue: string, columnConfig: ColumnConfig[]): T[] {
    const filterableRows: T[] = [];
    const inputWords = inputValue.trim().toLowerCase().split(GlobalTableFilterService.SPLIT_KEY).filter((word: string): boolean => word !== '');

    for (const rowData of rowsData) {
      if (this.matchFilterText<T>(rowData, columnConfig, inputWords)) {
        filterableRows.push(rowData);
      }
    }

    return filterableRows;
  }

  private matchFilterText<T>(rowData: T, columns: ColumnConfig[], inputWords: string[]): boolean {
    const wordsToFind = new Map();

    for (const curWord of inputWords) {
      for (const curColumn of columns) {
        if (typeof rowData[curColumn.field] === 'boolean') {
            continue;
        } else if (curColumn.header === COLUMN_HEADER.PUBLISHED_DATA) {
          continue;
        }

        if (rowData[curColumn.field] && rowData[curColumn.field].length > 0 && curColumn.field === 'cmpTypes') {
          const name: string = rowData[curColumn.field].map(element => element.cmpTypeName).join(', ');
          if (name.toLowerCase().includes(curWord)) {
            wordsToFind.set(curWord, '');
          }
        } else  if (rowData[curColumn.field] && rowData[curColumn.field].length > 0 && curColumn.field === 'shortDescription') {
          const name: string = rowData[curColumn.field].join(', ');
          if (name.toLowerCase().includes(curWord)) {
            wordsToFind.set(curWord, '');
          }
        } else if (curColumn.field.includes('.')) {
          const fieldInfo: {} | Primitive = curColumn.field
            .split('.')
            .reduce((acc: {} | Primitive, objKey: string): {} | Primitive => {
              return acc && acc.hasOwnProperty(objKey) ? acc[objKey] : acc;
            }, rowData);

          if (fieldInfo && typeof fieldInfo === 'string' && fieldInfo.toLowerCase().includes(curWord)) {
            wordsToFind.set(curWord, '');
          }
        } else if (rowData[curColumn.field] && typeof rowData[curColumn.field] === 'string' && rowData[curColumn.field].toLowerCase().includes(curWord)) {
          wordsToFind.set(curWord, '');
        } else if (rowData[curColumn.field] && rowData[curColumn.field].toString().toLowerCase().includes(curWord)) {
          wordsToFind.set(curWord, '');
        }
      }
    }

    return inputWords.length === wordsToFind.size;
  }
}
